'use strict'

import { loadComponent } from './utils/load-component';
import { getAllDigitalConcerts } from '../services/digital-inventory';
import { isLoggedIn } from '../utils/cookies';

const brightcoveAccount = window.AppConfig.brightcoveAccount;
const brightcovePlayerId = window.AppConfig.brightcovePlayerId;
const brightcovePlayerEmbed = window.AppConfig.brightcovePlayerEmbed;

loadComponent('digital-header', {
    props: {
        id: {
            type: Number,
        },
    },

    data() {
        return {
            ViewModel: {
                Loading: true,
                LoggedIn: false,
                Purchased: false,
                IframeSrc: null,
                StreamingOn: null,
                AvailableUntil: null,
                OffSaleDate: null,
                BuyPerformance: null,
                BuySubscription: null,
                SubscriptionCost: null,
            },
        }
    },

    beforeMount() {
        const assetPromise = getAllDigitalConcerts().then(response => {
            return response.find(item => {
                return parseInt(item.id, 10) === parseInt(this.id, 10);
            });
        }).catch(error => {
            console.error(error);
            return null;
        });

        assetPromise.then(assetResponse => {
            this.ViewModel.LoggedIn = isLoggedIn();

            if (assetResponse && assetResponse.type === 'video') {
                return this.handleVideo(assetResponse);
            }
        }).finally(() => {
            this.ViewModel.Loading = false;
        })
    },

    methods: {
        handleVideo(asset) {
            this.ViewModel.Purchased = asset.video_id;

            if (this.ViewModel.Purchased) {
                if (asset.video_type === 'Brightcove Video') {
                    this.ViewModel.IframeSrc = `https://players.brightcove.net/${brightcoveAccount}/${brightcovePlayerId}_${brightcovePlayerEmbed}/index.html?videoId=${asset.video_id}`;
                } else if (asset.video_type === 'Brightcove Experience') {
                    this.ViewModel.IframeSrc = `https://players.brightcove.net/${brightcoveAccount}/experience_${asset.video_id}/index.html`;
                } else if (asset.video_type === 'YouTube Video') {
                    this.ViewModel.IframeSrc = `https://www.youtube.com/embed/${asset.video_id}?modestbranding=1&rel=0`;
                } else if (asset.video_type === 'Vimeo Video') {
                    this.ViewModel.IframeSrc = `https://www.youtube.com/embed/${asset.video_id}?modestbranding=1&rel=0`;
                    'https://player.vimeo.com/video/${asset.video_id}?title=0&byline=0&portrait=0'
                } else if (asset.video_type === 'Wistia Video') {
                    this.ViewModel.IframeSrc = `https://fast.wistia.net/embed/iframe/${asset.video_id}`;
                }
            } else {
                this.ViewModel.BuyPerformance = asset.purchase_links.performance;
                this.ViewModel.BuySubscription = asset.purchase_links.subscription;
            }

            this.ViewModel.StreamingOn = asset.stream_panel.streaming_on;
            this.ViewModel.AvailableUntil = asset.stream_panel.available_until;
            this.ViewModel.OffSaleDate = asset.stream_panel.off_sale_date;
        },
    },
});
